import { makeStyles } from '@mui/styles';
import Button from 'apollo-react/components/Button';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { useFormSelector } from '../../custom-hooks';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { VALIDATION_DELAY } from '../../middlewares/formValidator';
import { getUITA, isTrue } from '../../utils/commonUtils';
import { submitForm } from '../actions/runtime.actions';
import ControlChangesIcon from '../components/ControlChangesIcon';
import { FORM_MODEL_ATTRIBUTES, SS_CONTROL_TYPE } from '../constants/form-manager.constants';
import { FCM_BUTTON_STYLES } from '../constants/runtime.constants';
import { getEvaluatedExpression } from '../selectors/form-manager.selectors';
import { isButtonDisabled } from '../selectors/runtime.selectors';

const useStyles = makeStyles(FCM_BUTTON_STYLES);

function SSButtonBulkUpload({
  id,
  label,
  needSignature,
  commandName,
  commandArgument,
  formKey,
  isEditor,
  isControlHiddenFCM,
  isControlAddedFCM,
  isControlChangedFCM,
  index,
}) {
  const classes = useStyles({ isControlAddedFCM });
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const translateString = useTranslation();

  const isDisabled = useFormSelector(isButtonDisabled, {
    controlType: SS_CONTROL_TYPE.BUTTON_BULK_UPLOAD,
  });
  const operationDelayMessage = useFormSelector(getEvaluatedExpression, {
    id,
    index,
    prop: FORM_MODEL_ATTRIBUTES.OPERATION_DELAY_MESSAGE,
  });

  const onClickHandler = () => {
    setTimeout(() => {
      dispatch(
        submitForm({
          formSubmitType: 'bulk-upload',
          commandName,
          commandArgument,
          needSignature: isTrue(needSignature),
          formKey,
          pathname,
          operationDelayMessage,
        })
      );
    }, VALIDATION_DELAY);
  };

  return (
    <span
      className={isControlAddedFCM || isControlChangedFCM ? classes.changesModeWrapper : null}
      ui-ta={getUITA('FormCtrl', 'SSButtonBulkUpload')}
      data-ss-id={id}
    >
      <Button
        variant="primary"
        color="primary"
        style={{ minWidth: '128px' }}
        onClick={onClickHandler}
        disabled={isEditor || isDisabled || isControlHiddenFCM}
      >
        {label || translateString('Bulk Upload')}
      </Button>
      {isControlChangedFCM && (
        <span className={classes.changesIcon}>
          <ControlChangesIcon id={id} />
        </span>
      )}
    </span>
  );
}

export default SSButtonBulkUpload;
